import { ReactNode, useContext, useEffect } from 'react'
import { InstantSearch } from 'react-instantsearch'
import { history } from 'instantsearch.js/es/lib/routers'
import { RouterProps } from 'instantsearch.js/es/middlewares'

import {
  indexName,
  indexNameEnglish,
  searchClientEmptyQueryDisabled,
} from '@models/Algolia'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'

type SearchProps = {
  children: ReactNode
  enablesRouting?: boolean
}

const CustomInstantSearch: React.FC<SearchProps> = ({
  children,
  enablesRouting = true,
}) => {
  const { locale } = useTranslation()
  const { entity } = useContext(StoreContext)
  const { user } = entity
  const targetIndexName = locale === 'en' ? indexNameEnglish : indexName

  useEffect(() => {
    if (user === undefined) {
      return
    }

    // TODO: userIdの形式を変更する
    // usetToken should be [a-zA-Z0-9_-]{1,64}
    user.userId !== undefined
      ? window.aa('setUserToken', user.userId.replace(/[^a-zA-Z0-9_-]/g, '_'))
      : window.aa('init', {
          useCookie: true,
          partial: true,
        })
  }, [user])

  const routing: RouterProps<
    { [indexName: string]: { query: string; ref?: string } },
    { q: string; ref?: string }
  > = {
    router: history({
      cleanUrlOnDispose: false,
    }),
    stateMapping: {
      stateToRoute(uiState) {
        const { query, ref } = uiState[targetIndexName]
        return { q: query, ref }
      },
      routeToState(routeState) {
        return {
          [targetIndexName]: {
            query: routeState.q,
            ref: routeState.ref,
          },
        }
      },
    },
  }

  return (
    <InstantSearch
      searchClient={searchClientEmptyQueryDisabled}
      indexName={targetIndexName}
      routing={enablesRouting ? routing : false}
      insights={true}
      future={{
        preserveSharedStateOnUnmount: false,
      }}
    >
      {children}
    </InstantSearch>
  )
}

export default CustomInstantSearch
